<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'study-editor.advance-study.modal.title' | translate }}</h4>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <jhi-advance-study
        [studyId]="studyId"
        [replicationNumber]="replicationNumber"
        [selectedInstances]="selectedInstances"
        [selectedDatasetId]="selectedDatasetId">
    </jhi-advance-study>
</div>
